import _isEqual from "lodash/isEqual";
export const isPropsChanged = (logos, layers, texts) => {
  const isLogosEqual = _isEqual(logos.prev, logos.next);
  const isLayersEqual = _isEqual(layers.prev, layers.next);
  const isTextsEqual = _isEqual(texts.prev, texts.next);
  return !isLayersEqual || !isLogosEqual || !isTextsEqual;
};
export const isThereNoAnyMedia = (logos, layers, texts) => !Object.keys(logos).length && !Object.keys(layers).length && !Object.keys(texts).length;